export default () => {
    return sessionStorage.getItem('app_user')
}